// CreateSquadCard.js
import React from 'react';
import { IconPlus } from '@tabler/icons-react'; // Plus icon
import { rem } from '@mantine/core'; // For consistent icon sizing
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const CreateSquadCard = ({ onClick }) => {
  const {t}=useTranslation();
  return (
    <div
      className="w-full relative bg-white border border-gray-200 rounded-lg shadow cursor-pointer
                 flex flex-col gap-2 items-center justify-center p-6 text-center
                 hover:shadow-lg transition-shadow duration-200"
      onClick={onClick}
    >
      <div className="p-4 rounded-full bg-blue-100 text-blue-600 mb-4">
        <IconPlus
          style={{ width: rem(48), height: rem(48) }} // Larger icon for prominence
          stroke={1.5}
        />
      </div>
      <h5 className="sm:text-xs lg:text-lg font-medium text-gray-900">
        {t("create_squad.title")}
      </h5>
      <span className="sm:text-sm lg:text-sm text-gray-500">
      {t("create_squad.subtitle")}
      </span>
    </div>
  );
};

export default CreateSquadCard;